import axios from "axios";

const { REACT_APP_BASE_URL, REACT_APP_EID } = process.env;

const client = axios.create({ baseURL: REACT_APP_BASE_URL });

const token = 'gKJI5R2L1bhXbVD4Qe9gaGX6NUR7ZM6EjnM30uQ5G79mdViUTHddYTYCFZNjltdiawhGk09Ee9kSpZexcFEbV0Sf6cQpHnj45mx-hzpYJuMj3wrTktoH0y5W1rq2kD5FD2MntTATq6gE8t16TuatQAHkGiO5vDMmeCXBIqN6shBa98JtqT9j1-c97p8Plu3bw_oJ8-tSjJlSOZ7muNttzp1LBvTdRUYlSNc6Rcgz7NKbs4-9113xcJAjc4Vt51Ug'
export const request = ({ ...options }) => {
    client.defaults.headers.common['e_id'] = REACT_APP_EID;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const widget = urlParams.get('widget')
    if (widget) {
        const auth_token = urlParams.get('auth_token')
        client.defaults.headers.common['token'] = auth_token
    } else {
        client.defaults.headers.common['token'] = token;
    }

    const onSuccess = response => response
    const onError = error => {
        return error.response
    }
    return client(options).then(onSuccess).catch(onError)
}

